import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaLinkedin, FaEnvelope, FaDownload } from 'react-icons/fa';

const Hero = () => {
  const primaryImages = ['/profile/1.png', '/profile/5.png', '/profile/3.png', '/profile/7.png','/profile/2.png', '/profile/6.png', '/profile/4.png'];
  const avatar = '/profile/avatar.svg';


  const imageSequence = primaryImages.flatMap(img => [img, avatar]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [flip, setFlip] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setFlip(true);
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % imageSequence.length);
        setFlip(false);
      }, 400); // Half the duration of the flip
    }, 2000);
    return () => clearInterval(interval);
  }, [imageSequence.length]);

  return (
    <section className="min-h-screen flex flex-col items-center justify-center text-center px-4">
      <motion.h1
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className="text-5xl md:text-7xl font-bold mb-4 text-white"
      >
        Victor Oluwatobi Akomolafe
      </motion.h1>

      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 1 }}
        className="text-xl md:text-2xl mb-8 text-softPurple"
      >
        DevOps | Solution Architect | SRE | IoT | Telematics | Engineering
      </motion.p>

      {/* Flip Animation Section */}
      <div className="relative w-40 h-40 mb-6 perspective">
        <motion.img
          key={imageSequence[currentIndex]}
          src={imageSequence[currentIndex]}
          alt="Rotating Visual"
          className="absolute w-full h-full object-cover rounded-full shadow-lg"
          animate={{ rotateY: flip ? 180 : 0 }}
          transition={{ duration: 0.8, ease: 'easeInOut' }}
          style={{ backfaceVisibility: 'hidden' }}
        />
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6, duration: 1 }}
        className="flex gap-6 flex-wrap justify-center"
      >
        {/* <a
          href="/resume.docx"
          download
          className="bg-softPurple hover:bg-glow px-6 py-3 rounded-xl text-white flex items-center gap-2 transition-colors"
        >
          <FaDownload />
          Download Resume
        </a> */}
        <a
          href="#contact"
          className="border border-softPurple px-6 py-3 rounded-xl hover:bg-softPurple flex items-center gap-2 transition-colors"
        >
          <FaEnvelope />
          Contact Me
        </a>
        <a
          href="https://www.linkedin.com/in/akomolafetech"
          target="_blank"
          rel="noreferrer"
          className="bg-white text-navy px-6 py-3 rounded-xl hover:bg-softPurple flex items-center gap-2 transition-colors"
        >
          <FaLinkedin />
          LinkedIn Profile
        </a>
      </motion.div>
    </section>
  );
};

export default Hero;
